import $ from 'jquery';

const MyOrders = () => {
  if ($('[data-section-type="INF-MyOrders"]').length === 0) { return; }

  $(document).on('click', '[data-view-order-details-button]', (e) => {
    const $button = $(e.currentTarget);
    const $collapsed_text = $button.find('[data-collapsed-text]');
    const $expanded_text = $button.find('[data-expanded-text]');
    const $order = $button.closest('[data-order]');
    const $order_details = $order.find('[data-order-details]');

    if ($order_details.hasClass('Order__expanded-info--open')) {
      $collapsed_text.show();
      $expanded_text.hide();
      $order_details.removeClass('Order__expanded-info--open');
      $order_details.css('max-height', 0);
      return;
      
    }

    $collapsed_text.hide();
    $expanded_text.show();
    $order_details.addClass('Order__expanded-info--open');
    $order_details.css('max-height', $order_details.children('[data-order-details-height]').outerHeight());
  });

  $(document).on('click', '[data-view-order-details-link]', (e) => {
    const $order = $(e.currentTarget).closest('[data-order]');
    $order.find('[data-view-order-details-button]').trigger('click');
  });

  // On page load, open your most recent order automatically on desktop
  // if (window.theme.breakpoints.current !== 'mobile') {
  //   $('[data-view-order-details-button]').eq(0).trigger('click');
  // }

  // If the order info is expanded, double click the button to resize it when the browser resizes.
  $(window).on('resize', () => {
    $('.Order__expanded-info--open').each((i, expanded) => {
      const $order = $(expanded).closest(['data-order']);
      const $button = $order.find('[data-view-order-details-button]');
      $button.trigger('click');
      $button.trigger('click');
    });
  });
};

export { MyOrders };